if (!customElements.get('lt-product-sticky-atc')) {
  customElements.define(
    'lt-product-sticky-atc',
    class LtProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-lt-sticky-button]');
        this.label = this.querySelector('[data-lt-sticky-label]');
        this.price = this.querySelector('[data-lt-sticky-price]');
        this.originalButton = document.querySelector('product-form .product-form__submit');
        this.productForm = this.originalButton?.closest('form');

        if (!this.button || !this.originalButton || !this.productForm) return;

        this.hidden = false;
        this.updateState();
        this.button.addEventListener('click', () => {
          this.updateState();
          if (!this.originalButton.disabled) this.originalButton.click();
        });

        document.addEventListener('change', (event) => {
          if (event.target.closest('variant-selects, variant-radios, .product-form')) {
            window.setTimeout(() => this.updateState(), 80);
          }
        });

        document.addEventListener('variant:change', () => {
          window.setTimeout(() => this.updateState(), 40);
        });

        this.observer = new IntersectionObserver(
          ([entry]) => {
            const passedPrimaryButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', passedPrimaryButton);
            document.body.classList.toggle('lt-sticky-atc-visible', passedPrimaryButton);
          },
          { threshold: 0.05 }
        );
        this.observer.observe(this.originalButton);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.body.classList.remove('lt-sticky-atc-visible');
      }

      updateState() {
        const primaryLabel = this.originalButton.querySelector('span')?.textContent?.trim();
        const livePrice = document.querySelector('.product__info-container .price');

        this.button.disabled = this.originalButton.disabled;
        if (primaryLabel) this.label.textContent = primaryLabel;
        if (livePrice?.textContent?.trim()) this.price.textContent = livePrice.textContent.trim();
      }
    }
  );
}


(() => {
  const detailsMedia = window.matchMedia('(max-width: 989px)');

  const syncResponsiveDetails = () => {
    document.querySelectorAll('[data-lt-mobile-details]').forEach((details) => {
      if (detailsMedia.matches) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  };

  syncResponsiveDetails();
  detailsMedia.addEventListener?.('change', syncResponsiveDetails);
  document.addEventListener('shopify:section:load', syncResponsiveDetails);

  const patchProductInfoFocus = () => {
    const ProductInfo = customElements.get('product-info');
    if (!ProductInfo || ProductInfo.prototype.ltPreventScrollFocusPatched) return;

    ProductInfo.prototype.ltPreventScrollFocusPatched = true;
    ProductInfo.prototype.renderProductInfo = function ({ requestUrl, targetId, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          callback(html);
          document.querySelector(`#${targetId}`)?.focus({ preventScroll: true });
        })
        .catch((error) => {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted by user');
          } else {
            console.error(error);
          }
          this.variantSelectors?.rejectPendingSelectPromise(error);
        });
    };
  };

  const patchVariantMediaScroll = () => {
    const MediaGallery = customElements.get('media-gallery');
    if (!MediaGallery || MediaGallery.prototype.ltVariantScrollPatched) return;

    MediaGallery.prototype.ltVariantScrollPatched = true;
    const originalSetActiveMedia = MediaGallery.prototype.setActiveMedia;

    MediaGallery.prototype.setActiveMedia = function (mediaId, prepend) {
      if (!prepend) return originalSetActiveMedia.call(this, mediaId, prepend);

      const scrollLeft = window.scrollX;
      const scrollTop = window.scrollY;
      const result = originalSetActiveMedia.call(this, mediaId, prepend);

      window.setTimeout(() => {
        window.scrollTo({ left: scrollLeft, top: scrollTop, behavior: 'auto' });
      });

      return result;
    };
  };

  if (customElements.get('product-info')) patchProductInfoFocus();
  else customElements.whenDefined('product-info').then(patchProductInfoFocus);

  if (customElements.get('media-gallery')) patchVariantMediaScroll();
  else customElements.whenDefined('media-gallery').then(patchVariantMediaScroll);
})();
